let functionsMetadata = [];
let selectedFunctionId = null;

// The initialize function must be run each time a new page is loaded
Office.onReady(async () => {
  document.getElementById("sideload-msg").style.display = "none";
  document.getElementById("app-body").style.display = "flex";
  document.getElementById("login").onclick = getKeySecret;
  document.getElementById("logout").onclick = logout;
  document.getElementById("show-overview").onclick = () => void switchPanel("overview");
  document.getElementById("show-function-help").onclick = () => void switchPanel("help");
  document.getElementById("function-search").addEventListener("input", renderFunctionList);
  document.getElementById("function-select").addEventListener("change", (event) => {
    selectedFunctionId = event.target.value || null;
    renderFunctionList();
    renderFunctionDetail(selectedFunctionId);
  });

  renderAuthState();

  await loadFunctionHelp();
});

function renderAuthState() {
  const rawUsername = localStorage.getItem("username");
  const title = document.getElementById("user-title");
  const loginNote = document.getElementById("login-note");
  const loginForm = document.getElementById("login-form");
  const logoutButton = document.getElementById("logout");

  if (rawUsername) {
    let displayName = rawUsername;
    title.title = rawUsername;
    if (displayName.length > 12) {
      displayName = displayName.substring(0, 12) + "...";
    }
    title.innerHTML = "Welcome! " + displayName;
    loginNote.hidden = true;
    loginForm.hidden = true;
    logoutButton.hidden = false;
    return;
  }

  title.title = "";
  title.innerHTML = "Please log in first.";
  loginNote.hidden = false;
  loginForm.hidden = false;
  logoutButton.hidden = true;
}

function logout() {
  localStorage.removeItem("username");
  localStorage.removeItem("appKey");
  localStorage.removeItem("appSecret");
  document.getElementById("email-box").value = "";
  document.getElementById("pass-box").value = "";
  document.getElementById("login-msg").innerHTML = "";
  renderAuthState();
}

async function switchPanel(panelName) {
  const showOverview = panelName === "overview";
  document.getElementById("overview-panel").classList.toggle("pane-panel--hidden", !showOverview);
  document.getElementById("overview-panel").classList.toggle("pane-panel--active", showOverview);
  document.getElementById("function-help-panel").classList.toggle("pane-panel--hidden", showOverview);
  document.getElementById("function-help-panel").classList.toggle("pane-panel--active", !showOverview);
  document.getElementById("show-overview").classList.toggle("pane-nav__button--active", showOverview);
  document.getElementById("show-function-help").classList.toggle("pane-nav__button--active", !showOverview);

  if (!showOverview) {
    await loadFunctionHelp(true);
  }
}

async function loadFunctionHelp(preserveSelection = false) {
  const loading = document.getElementById("help-loading");
  const error = document.getElementById("help-error");
  const layout = document.getElementById("help-layout");
  const previousSelectionId = selectedFunctionId;

  loading.hidden = false;
  error.hidden = true;
  layout.hidden = true;

  try {
    const response = await fetchFunctionMetadata();
    functionsMetadata = (response.functions || []).slice().sort((left, right) => left.name.localeCompare(right.name));
    const hasPreviousSelection = preserveSelection && functionsMetadata.some((item) => item.id === previousSelectionId);
    selectedFunctionId = hasPreviousSelection ? previousSelectionId : (functionsMetadata.length > 0 ? functionsMetadata[0].id : null);
    renderFunctionList();
    renderFunctionDetail(selectedFunctionId);
    layout.hidden = false;
    loading.hidden = true;
  } catch (fetchError) {
    loading.hidden = true;
    error.hidden = false;
    error.textContent = "Unable to load function help metadata.";
    console.log(fetchError);
  }
}

async function fetchFunctionMetadata() {
  const metadataPaths = ["/public/functions.json", "/functions.json", "functions.json"];
  let lastError = null;

  for (const metadataPath of metadataPaths) {
    try {
      const response = await fetch(metadataPath, { cache: "no-store" });
      if (!response.ok) {
        throw new Error(`Metadata request failed: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      lastError = error;
    }
  }

  throw lastError || new Error("Metadata not found.");
}

function renderFunctionList() {
  const searchTerm = document.getElementById("function-search").value.trim().toLowerCase();
  const select = document.getElementById("function-select");
  const filteredFunctions = functionsMetadata.filter((item) => {
    const description = item.description || "";
    return item.name.toLowerCase().includes(searchTerm) || description.toLowerCase().includes(searchTerm);
  });

  if (!filteredFunctions.some((item) => item.id === selectedFunctionId)) {
    selectedFunctionId = filteredFunctions.length > 0 ? filteredFunctions[0].id : null;
  }

  if (filteredFunctions.length === 0) {
    select.innerHTML = "";
    select.disabled = true;
    renderFunctionDetail(null);
    return;
  }

  select.disabled = false;
  select.innerHTML = filteredFunctions
    .map((item) => {
      const isSelected = item.id === selectedFunctionId ? ' selected="selected"' : "";
      return `<option value="${escapeHtml(item.id)}"${isSelected}>${escapeHtml(item.name)}</option>`;
    })
    .join("");

  select.value = selectedFunctionId || filteredFunctions[0].id;
}

function renderFunctionDetail(functionId) {
  const detail = document.getElementById("function-detail");
  const functionInfo = functionsMetadata.find((item) => item.id === functionId);

  if (!functionInfo) {
    detail.innerHTML = `
      <h3 class="help-detail__title">Select a function</h3>
      <p class="help-detail__description">Choose a function above to view its purpose, syntax, and parameter notes.</p>
    `;
    return;
  }

  const parameters = functionInfo.parameters || [];
  const signature = `${functionInfo.name}(${parameters
    .map((item) => item.optional ? `[${item.name}]` : item.name)
    .join(", ")})`;
  const matrixParameterNote = buildMatrixParameterNote(parameters);
  const parameterMarkup = parameters.length > 0
    ? parameters
        .map((parameter) => {
          const optionalTag = parameter.optional ? '<span class="help-parameter__tag">Optional</span>' : "";
          const typeLabel = parameter.dimensionality === "matrix" ? `${parameter.type}[][]` : parameter.type;
          return `
            <div class="help-parameter">
              <div class="help-parameter__header">
                <span class="help-parameter__name">${escapeHtml(parameter.name)}</span>
                <span class="help-parameter__type">${escapeHtml(typeLabel || "any")}</span>
                ${optionalTag}
              </div>
              <div class="help-parameter__description">${escapeHtml(parameter.description || "No parameter description available.")}</div>
            </div>
          `;
        })
        .join("")
    : '<div class="help-parameter"><div class="help-parameter__description">This function has no input parameters.</div></div>';

  detail.innerHTML = `
    <div class="help-detail__header">
      <h3 class="help-detail__title">${escapeHtml(functionInfo.name)}</h3>
      <p class="help-detail__description">${escapeHtml(functionInfo.description || "No description available.")}</p>
      <h4 class="help-detail__section-title">Function Signature</h4>
      <div class="help-detail__signature">${escapeHtml(signature)}</div>
    </div>
    <div class="help-detail__section">
      <h4 class="help-detail__section-title">Function Arguments</h4>
      ${parameterMarkup}
    </div>
    ${matrixParameterNote}
  `;
}

function buildMatrixParameterNote(parameters) {
  const matrixParameters = parameters.filter((parameter) => parameter.dimensionality === "matrix");
  const matrixParameterNames = matrixParameters
    .map((parameter) => parameter.name)
    .filter(Boolean);

  if (matrixParameterNames.length === 0) {
    return "";
  }

  const subject = joinWithAnd(matrixParameterNames);
  const requiredMatrixParameterNames = matrixParameters
    .filter((parameter) => !parameter.optional)
    .map((parameter) => parameter.name)
    .filter(Boolean);
  const matrixShapeNote = capitalizeFirstLetter(`${subject} may be row or column arrays.`);
  const sizeConstraintNote = buildMatrixSizeConstraintNote(requiredMatrixParameterNames);
  const inputModeNote = "Accepts single-cell or range-based inputs.";

  return `
    <div class="help-detail__section help-detail__matrix-note">
      <p class="help-detail__description">${escapeHtml(matrixShapeNote)} ${escapeHtml(sizeConstraintNote)} ${escapeHtml(inputModeNote)}</p>
    </div>
  `;
}

function joinWithAnd(items) {
  if (items.length <= 1) {
    return items[0] || "";
  }

  if (items.length === 2) {
    return `${items[0]} and ${items[1]}`;
  }

  return `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`;
}

function capitalizeFirstLetter(value) {
  if (!value) {
    return "";
  }

  return value.charAt(0).toUpperCase() + value.slice(1);
}

function buildMatrixSizeConstraintNote(requiredMatrixParameterNames) {
  if (requiredMatrixParameterNames.length < 2) {
    return "";
  }

  const subject = joinWithAnd(requiredMatrixParameterNames);
  const noun = requiredMatrixParameterNames.length === 2 ? "range" : "ranges";

  return `The input ${noun} for ${subject} must be the same size.`;
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export async function getKeySecret(){
  const config = require("pa_config");
  const url = config.API_URL.toString() + "account/secret/";
  // const url = "https://alfa.plutusanalytics.com/api/account/secret/";
  document.getElementById('login').setAttribute("disabled","true");
  const email = document.getElementById("email-box").value;
  const pass = document.getElementById("pass-box").value;
  if (email && pass){
    document.getElementById('login').setAttribute("disabled","true");
    let xhttp = new XMLHttpRequest();

    return new Promise(function(resolve, reject){
      xhttp.onreadystatechange = function(){
        if (xhttp.readyState !== 4) return;
        if (xhttp.status == 201){
          let payload = JSON.parse(xhttp.responseText);
          if (payload['app_key'].length > 0 && payload['app_secret'].length > 0){
            localStorage.setItem("username", payload['username']);
            localStorage.setItem("appKey", payload['app_key']);
            localStorage.setItem("appSecret", payload['app_secret']);
            document.getElementById("email-box").value = "";
            document.getElementById("pass-box").value = "";
            document.getElementById("login-msg").innerHTML = '<font color="green">Authenticated.</font>';
            document.getElementById('login').removeAttribute("disabled");
            renderAuthState();
            resolve("Authenticated.");
          } else{
            document.getElementById("login-msg").innerHTML = '<font color="red">No token! Please login web and create new secret.</font>';
            document.getElementById('login').removeAttribute("disabled");
            reject("Authentication failed.");
          }
        } else {
          document.getElementById("login-msg").innerHTML = '<font color="red">Authentication failed.</font>';
          document.getElementById('login').removeAttribute("disabled");
          reject("Authentication failed.");
        }
      };

      xhttp.open("POST", url);
      xhttp.setRequestHeader("Content-Type", "application/json");
      var data = "{\r\n    \"email\": \"" + email + "\",\r\n    \"password\": \"" + pass + "\"\r\n}";
      xhttp.send(data);
    });
  } else {
    document.getElementById("login-msg").innerHTML = '<font color="red">Please input EMAIL and PASSWORD!</font>';
    document.getElementById('login').removeAttribute("disabled");
    return "Invalid input!";
  }
}

export async function loadSecret(){
  const username =localStorage.getItem("username");
  const appKey = localStorage.getItem("appKey");
  const appSecret = localStorage.getItem("appSecret");
  console.log(appSecret);
}
